<template>
    <div>
        <div class="header-wrapper">
        </div>
        
        <div class="dashboard-content">
            <b-container>
                <b-row class="justify-content-md-center">
                    <b-col md="12" lg="8">
                        <div class="setting-wrapper">
                            <div class="heading">Base Info</div>

                            <div class="form-box">
                                <b-row>
                                    <b-col lg="6" md="6" sm="12">
                                        <div class="form-group">
                                            <div class="inp-label">Firstname</div>
                                            <div class="inp-box">
                                                <span class="fe-user"></span>
                                                <input type="text" v-model="form.firstname" id="fname">
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col lg="6" md="6" sm="12">
                                        <div class="form-group">
                                            <div class="inp-label">Lastname</div>
                                            <div class="inp-box">
                                                <span class="fe-user"></span>
                                                <input type="text" v-model="form.lastname" id="lname">
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col lg="6" md="6" sm="12">
                                        <div class="form-group">
                                            <div class="inp-label">Middlename</div>
                                            <div class="inp-box">
                                                <span class="fe-user"></span>
                                                <input type="text" v-model="form.middlename" id="mname">
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                                

                                <b-row class="mt-4">
                                    <b-col lg="6" md="6" sm="12">
                                        <div class="form-group">
                                            <div class="inp-label">Email</div>
                                            <div class="inp-box">
                                                <span class="fe-mail"></span>
                                                <input type="text" v-model="form.email" id="email">
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col lg="6" md="6" sm="12">
                                        <div class="form-group">
                                            <div class="inp-label">Phone</div>
                                            <div class="inp-box">
                                                <span class="fe-phone"></span>
                                                <input type="text" v-model="form.phone" id="phone">
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>

                                <b-row class="mt-4">
                                <b-col lg="6" md="6" sm="12">
                                        <div class="form-group">
                                            <div class="inp-label">City</div>
                                            <div class="inp-box">
                                                <span class="fe-map"></span>
                                                <input type="text" v-model="form.city" id="city">
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col lg="6" md="6" sm="12">
                                        <div class="form-group">
                                            <div class="inp-label">Gender</div>
                                            <l-toggle optionOne="Male" optionTwo="Female" @toggle="setGender"></l-toggle>
                                        </div>
                                    </b-col>
                                </b-row>

                                <b-row class="mt-4">
                                    <b-col cols="12">
                                        <div class="heading">Church Info</div>
                                    </b-col>
                                    <b-col lg="6" md="6" sm="12">
                                        <div class="form-group">
                                            <div class="inp-label">Branch</div>
                                            <l-select :options="branch" :default="form.church" @input="selectChurch"></l-select>
                                        </div>
                                    </b-col>
                                    <b-col lg="6" md="6" sm="12">
                                        <div class="form-group">
                                            <div class="inp-label">Role</div>
                                             <l-select :options="roles" :default="form.role" @input="selectRole"></l-select>
                                        </div>
                                    </b-col>
                                    <!-- <b-col lg="6" md="6" sm="12">
                                        <div class="form-group">
                                            <div class="inp-label">Primary Department</div>
                                            <l-select :options="departments" :default="form.department"  @input="selectDepartment"></l-select>
                                        </div>
                                    </b-col> -->
                                </b-row>
                                <!-- <b-row>
                                    <b-col lg="6" md="6" sm="12">
                                        <div class="form-group">
                                            <div class="inp-label">Your Pastor</div>
                                            <l-select :options="pastors" @input="selectPastor"></l-select>
                                        </div>
                                    </b-col>
                                     <b-col lg="6" md="6" sm="12">
                                        <div class="form-group">
                                            <div class="inp-label">Who is your leader </div>
                                            <l-select :options="leaders" @input="selectLeader"></l-select>
                                        </div>
                                    </b-col>
                                </b-row> -->
                                <!-- <b-row class="mt-3">
                                    <b-col lg="6" md="6" sm="12">
                                        <div class="form-group">
                                            <div class="inp-label">Are you a new leader</div>
                                            <l-toggle></l-toggle>
                                        </div>
                                    </b-col>
                                     <b-col lg="6" md="6" sm="12">
                                        <div class="form-group">
                                            <div class="inp-label">Do you want to join online</div>
                                             <l-toggle></l-toggle>
                                        </div>
                                    </b-col>
                                </b-row> -->
                                <b-row class="mt-3 justify-content-md-center">
                                    <b-col>
                                        <div class="btn-save"><span class="fe-save"></span> Save</div>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import lselect from '@/components/select.vue'
    import ltoggle from '@/components/toggle.vue'
    import {mapGetters} from 'vuex';

    export default {
        components: {
            LSelect: lselect,
            LToggle: ltoggle
        },
        data(){
            return {
                form: {
                    firstname: '',
                    lastname: '',
                    middlename: '',
                    email: '',
                    phone: '',
                    city: '',
                    gender: 'male',
                    church: '',
                    role: '',
                    department: '',
                    leader: '',
                    pastor: '',
                    new_leader: false,
                    go_online: false
                },
                departments: [
                    'Media',
                    'Users',
                    'Drama',
                    'Dance',
                    'Spoken Word'
                ],
                roles: [
                    'Leader',
                    'Elder',
                    'Pastor',
                    'Branch Pastor',
                    'Council Member'
                ],
                branch: [
                    'Alpha',
                    'Asafo',
                    'Awoshie',
                    'Cape Coast',
                    'Diaspora',
                    'Ho',
                    'Kaneshie',
                    'Kasoa',
                    'Koforidua',
                    'Kpando',
                    'Kronum',
                    'Obuasi',
                    'Santasi',
                    'Spintex',
                    'Sunyani',
                    'Swedru',
                    'Takoradi',
                    'Tamale',
                    'Tema',
                    'Thesaurus',
                    'Wa',
                    'Winneba'
                ],
                pastors: [
                    'Kekeli Buckner'
                ],
                leaders: []
            }
        },
        computed: {
            ...mapGetters({user: 'USER'})
        },
        methods: {
            selectChurch(val){
                this.form.church = val
            },
            selectDepartment(val){
                this.form.department = val
            },
            selectRole(val){
                this.form.role = val
            },
            selectPastor(val){
                this.form.pastor = val
            },
            selectLeader(val){
                this.form.leader = val
            },
            setGender(val){
                if(val){
                    this.form.gender = 'male'
                }else{
                    this.form.gender = 'female'
                }
            },
            setNewLeader(val){
                if(val){
                    this.form.new_leader = true
                }else{
                    this.form.new_leader = false
                }
            },
            setOnline(val){
                if(val){
                    this.form.go_online = true
                }else{
                    this.form.go_online = false
                }
            },
            getUser(){
                this.$http.get('user/'+this.user._id)
                .then(res => {
                    let user = res.body;
                    localStorage.setItem("user", JSON.stringify(user))
                    this.$store.commit('SET_SESSION')
                    this.prepareUser(user)
                })
                .catch(err => {
                    console.log(err)
                })
            },
            async prepareUser(data){
                this.form.firstname = data.firstname
                this.form.lastname = data.lastname
                this.form.middlename = data.middlename
                this.form.email = data.email
                this.form.phone = data.phone
                this.form.city = data.city
                if(data.gender[0] == 'male'){
                    this.form.gender = true
                }else{
                    this.form.gender = false
                }
                this.form.church = data.church[0].toUpperCase() + data.church.slice(1);
                let role = data.role[0]
                this.form.role = role[0].toUpperCase() + role.slice(1)
                // this.form.department = data.department
                this.form.leader = data.leader
                this.form.pastor = data.pastor
            },

            async allUser(){
                this.$http.get('users/')
                .then(async res => {
                    let list = res.body.users
                    // this.filterPastor(list)
                    this.leaders = await Promise.all(list.map(item => {
                        let name = ''
                        if(item.firstname){
                            name = item.firstname[0].toUpperCase() + item.firstname.slice(1)
                        }

                        if(item.middlename && typeof item.middlename == 'string'){
                            name = name+' '+ item.middlename[0].toUpperCase() + item.middlename.slice(1)
                        }

                        return name
                    }))
                })
                .catch(err => {
                    console.log(err)
                })
            }
        },
        created(){
            this.getUser();
            this.allUser()
        }
    }
</script>

<style lang="scss" scoped>
    select{
        display: none;
    }
    .setting-wrapper{
        .heading{
            font-size: 25px;
            text-align: center;
            font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
            font-weight: bold;
            color: #232353;
            margin: 60px 0 20px  0;
            &:first-child{
                margin-top: 20px;
            }
        }
    }

    .form-group{
        .inp-label{
            margin-left: 5px;
            margin-bottom: 10px;
            font-weight: bold;
            color: #131381;
        }
        .inp-box{
            width: 100%;
            height: 42px;
            background-color: #ffffff;
            border-radius: 25px;
            overflow: hidden;
            padding: 5px 20px;
            border: 2px solid  #171785;
            span{
                color: #131381;
                font-size: 18px;
                line-height: 30px;
            }

            input {
                width: calc(100% - 30px);
                margin-left: 10px;
                height: 100%;
                border: none;
                background-color: transparent;
                outline: none;
                color: #131381
            }
        }
    }
    .btn-save{
        background-color: #171785;
        padding: 7px 15px;
        color: white;
        border-radius: 25px;
        width: 150px;
        margin: 0 auto;
        text-align: center;
        margin-top: 20px;
    }
</style>